import { render, staticRenderFns } from "./NavDrawerAdmin.vue?vue&type=template&id=2b2be95f&"
import script from "./NavDrawerAdmin.vue?vue&type=script&lang=js&"
export * from "./NavDrawerAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports